export const layoutConfig = {
	css: "vault-layout",
	rows: [
		{
			id: "topbar",
			css: "vault-topbar",
		},
		{
			id: "vault",
			css: "vault-file-grid",
		},
	],
};

export const layoutConfigWithoutTopbar = {
	css: "vault-layout",
	rows: [
		{
			id: "vault",
			css: "vault-file-grid",
		},
	],
};
